import { render } from "./page.vue?vue&type=template&id=bc10caea&scoped=true"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"

import "./page.vue?vue&type=style&index=0&id=bc10caea&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc10caea"]])

export default __exports__